import { configureStore } from "@reduxjs/toolkit";
import hostnameReducer from "./slices/hostnameSlice";
import liveSessionReducer from "./slices/liveSessionSlice";
import modalsReducer from "./slices/modalsSlice";
import storeReducer from "./slices/storeSlice";

export const store = configureStore({
  reducer: {
    store: storeReducer,
    modals: modalsReducer,
    liveSession: liveSessionReducer,
    hostname: hostnameReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
